import { render, staticRenderFns } from "./FlexibleContent.vue?vue&type=template&id=0bea1571"
import script from "./FlexibleContent.vue?vue&type=script&lang=js"
export * from "./FlexibleContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports